import React, { useEffect } from 'react';
import { defaults, Line, Bar, Doughnut } from 'react-chartjs-2';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import api from './../../../services/axios'
import Loading from './../../../compoments/Loading';
import NavBack from './../../NavBack';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import DatePicker from './../../../compoments/DatePicker';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const drawerWidth = 240;
defaults.font.size = 24

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    backgroundColor: '#F2F2F2',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

const options = {
  plugins: {
    tooltip: {
      mode: 'index'
    }
  },
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      position: 'left',
      scalePositionLeft: false,
      type: 'linear',
    },
    y1: {
      id: 'y1',
      position: 'right',
      scalePositionLeft: false,
      type: 'linear',
      ticks: {
        callback: function (value) {
          return value + ' %'
        }
      }
    },
  },

};

function renderGrafico(da) {
  return <div style={{ height: '70vh' }}><Doughnut data={da}
    options={{
      animation: {animateRotate: false},
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          callbacks: {
            label: function (ctx) {
              return ctx.label + ': ' + Math.round(ctx.raw) + '%';
            }
          }
        }
      }
    }}
  /></div>
}

export default function Perguntas() {
  const [open, setOpen] = React.useState(false);
  const graficos = ['volAtdUsuario']
  const titleHeader = 'Voltar'
  const classes = useStyles();
  const [tableA, setTableA] = React.useState([]);
  const [tableB, setTableB] = React.useState([]);
  const [operador, setOperador] = React.useState(null);
  const [operadorSelected, setOperadorSelected] = React.useState(null);
  const [userId, setUserId] = React.useState('');
  const [start, setStart] = React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(0)
    dt.setMinutes(0);
    return dt;
  });
  const [end, setEnd] = React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(23)
    dt.setMinutes(59);
    return dt;
  });


  const dateToString = (date, time, format = false) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    let timeString = '';
    if (time) {
      timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    }
    if (!format) {
      return yyyy + '-' + mm + '-' + dd + '' + timeString;
    }
    return dd + '/' + mm + '/' + yyyy + ' ' + timeString;
  }

  const addDays = function (date, daysToAdd) {
    var _24HoursInMilliseconds = 86400000;
    return new Date(date.getTime() + daysToAdd * _24HoursInMilliseconds);
  }

  const loadData = async () => {
    setLoading(true)

    setOperadorSelected(operador)
    let startP = start ? dateToString(start, false) : '';
    let endP = end ? dateToString(end, false) : '';
    let operadorP = operador ? operador : '';

    const { data } = await api.get('v2/pesquisas/?start=' + startP + '&end=' + endP + '&operador=' + operadorP);
    setLoading(false)
    setDtUm(data.data[0])
    setDtDois(data.data[1])
    setTableA(data.dataTable[0] || [])
    setTableB(data.dataTable[1] || [])
  }

  useEffect(() => {
    loadOperadores()
    loadData()
    return () => {
    }
  }, [])

  const [dtUm, setDtUm] = React.useState(null);
  const [dtDois, setDtDois] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [operadores, setOperadores] = React.useState([]);

  const loadOperadores = async () => {
    const data = await api.get('/v2/pesquisas-operadores');
    setOperadores(data.data.data)
  }

  return (
    <>
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <NavBack
          titleHeader={titleHeader}
        />
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} >
          <Container maxWidth={false} className={classes.container}>
            <div style={{ padding: '64px 40px', height: '80vh' }}>
              <>
                <h1 className='title'>Pesquisas</h1>
                <div className='header' style={{ paddingTop: 0, height: '10rem', marginBottom: -50 }}>
                  <Grid container spacing={4}>
                    <Grid item xs={2} >
                      <DatePicker
                        value={start}
                        onChange={setStart}
                        label={'Data'}
                      />
                    </Grid>
                    <Grid item xs={2} style={{ alignSelf: 'center' }}>
                      <DatePicker
                        value={end}
                        onChange={setEnd}
                        label={'Até a data'}
                      />
                    </Grid>
                    <Grid item xs={3} style={{ alignSelf: 'center' }}>
                      <Autocomplete
                        value={operador}
                        onChange={(event, newValue) => {
                          setOperador(newValue);
                        }}
                        id="combo-box-demo"
                        options={operadores}
                        getOptionLabel={(name) => name}
                        renderInput={(params) => <TextField value={userId} {...params} label="Ramal" variant="outlined" />}
                      />
                    </Grid>
                    <Grid item xs={2} style={{ alignSelf: 'center', marginTop: 20 }}>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={() => loadData(start, end)}
                      >
                        Gerar
                          </Button>
                    </Grid>
                  </Grid>
                </div>
                {loading ? <Loading /> :
                  <>
                    { tableA.length<1 ? <h3>Nenhum dado encontrado</h3> :
                    <>
                    <h1>{operadorSelected ? 'Operador(a) ' + operadorSelected : 'Geral'}</h1>
                    <Grid container spacing={4}>
                      <Grid item xs={6} style={{ alignSelf: 'center' }}>
                        <h3>Pergunta 1</h3>
                        {renderGrafico(dtUm)}
                      </Grid>
                      <Grid item xs={6} style={{ alignSelf: 'center' }}>
                        <h3>Avaliação</h3>
                        {renderGrafico(dtDois)}
                      </Grid>
                      <Grid item xs={12} style={{ alignSelf: 'center', marginBottom: -20 }}>
                        <h3>Mais detalhes</h3>
                      </Grid>
                      <Grid item xs={6} style={{ alignSelf: 'top' }}>
                        <TableContainer component={Paper}>
                          <Table className={classes.table} size="small" aria-label="a dense table">
                            <TableHead>
                              <TableRow>
                                <TableCell colSpan={2} style={{ fontSize: 24, padding: 15 }}>Pergunta 1</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableHead>
                              <TableRow>
                                <TableCell>Opção</TableCell>
                                <TableCell>Quantidade</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {tableA.map((row, k) => (
                                <TableRow key={k}>
                                  <TableCell component="th" scope="row">
                                    {row.resposta}
                                  </TableCell>
                                  <TableCell align="left">{row.qtd}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                      <Grid item xs={6} style={{ alignSelf: 'top' }}>
                        <TableContainer component={Paper}>
                          <Table className={classes.table} size="small" aria-label="a dense table">
                            <TableHead>
                              <TableRow>
                                <TableCell colSpan={2} style={{ fontSize: 24, padding: 15 }}>Pergunta Avaliação</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableHead>
                              <TableRow>
                                <TableCell>Opção</TableCell>
                                <TableCell>Quantidade</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {tableB.map((row, k) => (
                                <TableRow key={k}>
                                  <TableCell component="th" scope="row">
                                    {row.resposta}
                                  </TableCell>
                                  <TableCell align="left">{row.qtd}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                    </>
                    }
                  </>}
              </>
            </div>
          </Container>
        </div>
      </main>
    </>
  )
}